import { createUseEntityList } from 'api/base-hooks';
import { OptionListResponse } from './option-types';
import { optionApi } from './option';

const SECTION = 'partner-options';

export const createUseOptionList = (partnerId: number) =>
  createUseEntityList<OptionListResponse>(`${SECTION}:${partnerId}`, () => optionApi.getList(partnerId));
